




import { Vue, Component, Watch } from 'vue-property-decorator';
import { unionIdIsBind } from '@/api/api';
import { isWeiXin } from '@/common/ts/common';
import { Toast } from 'vant';
@Component
export default class BindDemo extends Vue {
  async mounted() {
    const data = {
      type: 2,
      unionId: window.localStorage.getItem('unionid'),
    };
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游APP打开');
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(`/BindPhone?url=${location.href}`);
      }
    }
  }
}
